<p-sidebar [(visible)]="sectionFiltrageOuverte"
           position="right"
           (onHide)="appliquerFiltres()"
           class="sidebar-filtrage-trajets">
	<ng-template pTemplate="header">
		<div class="filtrage-header">
			<h2>{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.TITRE' | translate }}</h2>
		</div>
	</ng-template>
	<p-divider></p-divider>
	<ng-template pTemplate="content">
		<form [formGroup]="filtresForm" (ngSubmit)="appliquerFiltres()">
			<div class="section-filtre">
				<div class="titre">
					{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.GENERAL' | translate }}
				</div>
				<div class="conteneur-champs">
					<div class="switch-input">
						<p-inputSwitch formControlName="afficherTrajetsPasses"></p-inputSwitch>
						<label for="afficherTrajetsPasses">{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.AFFICHER_TRAJETS_PASSES' | translate }}</label>
					</div>
					<div class="input-label">
						<label for="statutsTrajet" class="multiselect-label">{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.STATUT' | translate }}</label>
						<p-multiSelect formControlName="statutsTrajet"
						               maxSelectedLabels="1"
						               [options]="statutsTrajet()"
						               placeholder="{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.SELECTIONNER_STATUT' | translate }}"
						               selectedItemsLabel="{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.STATUT_MULTIPLE' | translate }}"
						               appendTo="body"
						               (onClear)="reinitialiserFiltreStatut()"
						               [showClear]="true">
						</p-multiSelect>
					</div>
				</div>
			</div>

			<div class="section-filtre">
				<div class="titre">
					{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.TRAJET' | translate }}
				</div>
				<div class="conteneur-champs">
					<div class="input-label">
						<label for="lieuDepart">{{ 'GESTION_NAVETTE.LIEU_DEPART' | translate }}</label>
						<app-lieux-autocomplete formControlName="lieuxDepart"
						                        [suggestions]="suggestionsLieux()"/>
					</div>
					<div class="input-label">
						<label for="lieuArrivee">{{ 'GESTION_NAVETTE.LIEU_ARRIVEE' | translate }}</label>
						<app-lieux-autocomplete formControlName="lieuxArrivee"
						                        [suggestions]="suggestionsLieux()"/>
					</div>
				</div>
			</div>

			<div class="section-filtre">
				<div class="titre-section-filtre">
					<div class="titre">
						{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.HORAIRES' | translate }}
					</div>
					<i class="pi pi-info-circle" pTooltip="{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.INDICATION_FILTRAGE_HORAIRES' | translate }}"></i>
				</div>
				<div class="conteneur-champs">
					<div class="input-label">
						<label for="heureDepart">{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.HEURE_DEPART' | translate }}</label>
						<p-calendar formControlName="heureDepart"
						            [timeOnly]="true"
						            [showIcon]="true"
						            iconDisplay="input">
							<ng-template pTemplate="inputicon">
								<i class="pi pi-clock"></i>
							</ng-template>
						</p-calendar>
					</div>
					<div class="input-label">
						<label for="heureArrivee">{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.HEURE_ARRIVEE' | translate }}</label>
						<p-calendar formControlName="heureArrivee"
						            [timeOnly]="true"
						            [showIcon]="true"
						            iconDisplay="input">
							<ng-template pTemplate="inputicon">
								<i class="pi pi-clock"></i>
							</ng-template>
						</p-calendar>
					</div>
				</div>
			</div>

			<div class="section-filtre">
				<div class="titre">
					{{ 'GESTION_NAVETTE.NOMBRE_PLACES' | translate }}
				</div>
				<div class="conteneur-champs">
					@if (this.filtresForm.hasError('minimumSuperieurMaximum')) {
						<span class="erreur-validation">{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.ERREUR.MINIMUM_SUPERIEUR_MAXIMUM' | translate }}</span>
					}
					<div class="input-label">
						<label for="minimumPlaces">{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.MINIMUM' | translate }}</label>
						<p-inputNumber formControlName="minimumPlaces" [min]="0" [max]="100" maxlength="3"/>
					</div>
					<div class="input-label">
						<label for="maximumPlaces">{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.MAXIMUM' | translate }}</label>
						<p-inputNumber formControlName="maximumPlaces" [min]="0" [max]="100" maxlength="3"/>
					</div>
				</div>
			</div>
		</form>
	</ng-template>
	<ng-template pTemplate="footer">
		<div class="boutons">
			<p-button type="button"
			          (onClick)="reinitialiserFiltres()"
			          styleClass="p-button-link"
			          label="{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.BTN_REINITIALISER' | translate }}"/>

			<p-button type="submit"
			          label="{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.BTN_APPLIQUER' | translate }}"
			          (onClick)="appliquerFiltres()"/>
		</div>
	</ng-template>
</p-sidebar>

<p-button type="button"
          (onClick)="ouvrirFiltres()"
          [icon]="this.filtresActifs() ? 'pi pi-filter-fill' : 'pi pi-filter'"
          [disabled]="estBoutonFiltreDesactive()"
          label="{{ 'GLOBAL.FILTRER' | translate }}"/>